/**
 * Group management helpers for Upload Hub file grouping.
 */

/**
 * Check if a file can be grouped (only EFDA/COMMS files).
 */
export function canGroup(file) {
  return file?.templateType === 'efda' || file?.templateType === 'comms';
}

/**
 * Get all file IDs that belong to a group.
 */
export function getGroupFileIds(groups, groupId) {
  return groups[groupId]?.fileIds || [];
}

/**
 * Check if all files in a group have resolved their supplier.
 */
export function isGroupSupplierResolved(files, group) {
  return !!group?.resolvedSupplierId;
}

/**
 * Get the next unresolved file ID from the ordered file list.
 */
export function getNextUnresolvedFileId(fileOrder, files, excludeFileId) {
  return fileOrder.find(
    (fid) =>
      fid !== excludeFileId &&
      files[fid]?.status !== 'completed' &&
      files[fid]?.status !== 'skipped',
  );
}

/**
 * Check if a file's group has a resolved supplier for pre-fill.
 */
export function shouldPreFillSupplier(file, groups) {
  if (!file?.groupId) return null;
  const group = groups[file.groupId];
  if (!group?.resolvedSupplierId) return null;
  return {
    supplierId: group.resolvedSupplierId,
    supplierName: group.resolvedSupplierName,
  };
}

/**
 * Check if a file's group is same_all with a resolved installation for pre-fill.
 */
export function shouldPreFillInstallation(file, groups) {
  if (!file?.groupId) return null;
  const group = groups[file.groupId];
  if (!group?.resolvedInstallationId) return null;
  if (group.groupType !== 'same_all') return null;
  return {
    installationId: group.resolvedInstallationId,
    installationName: group.resolvedInstallationName,
  };
}
